import isoStringToDate from 'utils/dates/isoStringToDate'

export const caseDateForPicker = (raw: unknown): Date | null => {
  if (raw == null || raw === '') return null
  if (raw instanceof Date) return raw
  const normalized = isoStringToDate(raw as string)
  return normalized instanceof Date ? normalized : null
}

export default caseDateForPicker
